const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f-]{27,}$/i;

export const toAnalyticsRoute = (pathname: string) => {
  const normalized = pathname
    .split("/")
    .map((part) => UUID_PATTERN.test(part) || /^\d+$/.test(part) ? ":id" : part)
    .join("/");
  return normalized || "/";
};
